import * as tslib_1 from "tslib";
import { Base } from "../../components/base-component";
import "./form-item-home-services-switch.component.scss";
var FormItemHomeServicesSwitch = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemHomeServicesSwitch, _super);
    function FormItemHomeServicesSwitch(element) {
        return _super.call(this, element) || this;
    }
    FormItemHomeServicesSwitch.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = this.element.querySelector(".js-apply-now__button");
        this.confirmContactNumberBtn = this.element.querySelector("input[name=confirm-phone-number]");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
    };
    FormItemHomeServicesSwitch.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.showLessBtn) {
            this.showLessBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showLessBtn.setAttribute("hidden", "true");
                _this.showMoreBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
            });
        }
        if (this.showMoreBtn) {
            this.showMoreBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.showMoreBtn.setAttribute("hidden", "true");
                _this.showLessBtn.removeAttribute("hidden");
                _this.dataPrivacyDetailArea.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupHideBtn) {
            this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
                _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
                _this.dataSharingGroupShowBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingGroupShowBtn) {
            this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingGroupTextArea.removeAttribute("hidden");
                _this.dataSharingGroupHideBtn.removeAttribute("hidden");
                _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyHideBtn) {
            this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
                _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharing3rdPartyShowBtn) {
            this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
                _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
                _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
            });
        }
        if (this.dataSharingBoardersShowBtn) {
            this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.removeAttribute("hidden");
                _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
            });
        }
        if (this.dataSharingBoardersHideBtn) {
            this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
                e.preventDefault();
                _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
                _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
                _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        var _contactNumber = this.form.querySelector("input[name=phone-number]");
        var _contactConfirmNumber = this.form.querySelector("input[name=confirm-phone-number]");
        // Ok key
        console.log(_contactNumber, _contactConfirmNumber);
        if (this.confirmContactNumberBtn) {
            console.log("inside if block");
            this.confirmContactNumberBtn.addEventListener("blur", function (e) {
                e.preventDefault();
                console.log("inside blur event");
                _this.validateConfirmContactNumber(_contactNumber, _contactConfirmNumber);
            });
        }
    };
    FormItemHomeServicesSwitch.prototype.validateConfirmContactNumber = function (contactNumber, contactConfirmNumber) {
        var error = ["Confirm Phone number is not match"];
        var isValid = true;
        var _contactConfirmNumber = this.form.querySelector("input[name=confirm-phone-number]");
        if (contactNumber.value !== contactConfirmNumber.value) {
            //  Password doesnot match
            isValid = false;
            this.validationService.addError(_contactConfirmNumber, error);
        }
        console.log(isValid);
        return isValid;
    };
    FormItemHomeServicesSwitch.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemHomeServicesSwitch.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // additional containers
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        var firstname = this.form.querySelector("input[name=first-name]");
        var surname = this.form.querySelector("input[name=sur-name]");
        var said = this.form.querySelector("input[name=identification-type]");
        var contact = this.form.querySelector("input[name=phone-number]");
        var emailAddress = this.form.querySelector("input[name=email-address]");
        var popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var productname = this.form.querySelector("input[name=product-name]");
        console.log(form);
        var _postData = {
            firstName: firstname ? firstname.value : "",
            surName: surname ? surname.value : "",
            identificationNumber: said ? said.value : "",
            contactNumber: contact ? contact.value : "",
            emailAddress: emailAddress ? emailAddress.value : "",
            dataPrivacyConsent: popiaConsent
                ? popiaConsent.checked
                    ? "YES"
                    : "NO"
                : "NO",
            dataSharingWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-group"),
            dataSharingWithThirdPartiesMarketingConsent: this.getDataConsentValue(form, "data-sharing-3rd-party"),
            dataSharingAcrossBordersWithinOurGrpMarketingConsent: this.getDataConsentValue(form, "data-sharing-boarders"),
            product: productname.value,
        };
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var url = "/leadsutils/homeloanswitchapp";
        var config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
            },
        };
        // service
        this.formsService
            .postForm(url, _postData, config)
            .then(function (response) {
            // Always show success message / no response from server (sending email)
            _this.analyticsService.dtmFormComplete("complete", response.code, false, "", emailAddress.value, contact.value);
            loader.classList.remove("active");
            thankYou.classList.add("active");
            success.classList.add("active");
            error.classList.add("hidden");
        })
            .catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            fieldsContainer.classList.remove("hidden");
        });
    };
    return FormItemHomeServicesSwitch;
}(Base));
export { FormItemHomeServicesSwitch };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-home-services-switch/form-item-home-services-switch.component.ts
// module id = 1067
// module chunks = 0